<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>容器管理</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in storehouseIds"
        v-if="item.key !== -1"
        :key="item.key"
        class="status"
        :class="{ active: origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.box_no"
                    placeholder="分箱ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.type_no"
                    placeholder="内容"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-select v-model="form.status" filterable placeholder="状态">
                  <el-option value="">全部</el-option>
                  <el-option
                    v-for="item in status_list"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>

                <el-select
                  v-model="form.group_id"
                  filterable
                  placeholder="组别"
                >
                  <el-option value="">全部</el-option>
                  <el-option
                    v-for="(item, key) in resData.group"
                    :key="key"
                    :label="item"
                    :value="key"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.type" filterable placeholder="类型">
                  <el-option
                    v-for="(item, key) in resData.types"
                    :key="key"
                    :label="item"
                    :value="key"
                  >
                  </el-option>
                </el-select>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="manyVisible = true"
            >批量入库</el-button
          >
          <el-button
            style="margin-left: auto"
            type="danger"
            size="mini"
            @click="unBand(0)"
            >批量解绑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="
              bandVisible = true;
              title = '容器出库';
              set_type = 1;
            "
            >容器出库</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="
              bandVisible = true;
              title = '容器入库';
              set_type = 2;
            "
            >容器入库</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              label="分箱ID"
              prop="box_no"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="group_name"
              label="组别"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="box_type"
              label="类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="type_no"
              label="绑定内容"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status_text"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="更新人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              label="更新时间"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="unBand(scope.row.box_id)"
                  >清除绑定</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
          :title="title"
          :visible.sync="bandVisible"
          width="60%"
          center
          :close-on-click-modal="false"
          :show-close="false"
        >
          <el-form :model="form">
            <el-form-item v-if="set_type == 2" label="选择组别">
              <el-select
                v-model="form.set_group_id"
                filterable
                placeholder="选择组别"
              >
                <el-option
                  v-for="(item, key) in resData.group"
                  :key="key"
                  :label="item"
                  :value="key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="输入箱号">
              <el-input
                v-model="set_box_no"
                style="width: 70%; float: left"
                @keyup.native.enter="addNo"
              ></el-input>
              <span>&nbsp;&nbsp;&nbsp;{{ box_num }}个</span>
            </el-form-item>
            <el-tag
              v-for="tag in box_nos"
              :key="tag"
              closable
              :disable-transitions="false"
              @close="removeNo(tag)"
            >
              {{ tag }}
            </el-tag>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="
                bandVisible = false;
                box_nos = [];
                box_num = 0;
              "
              >取 消</el-button
            >
            <el-button type="primary" @click="band">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="批量入库"
          :visible.sync="manyVisible"
          width="60%"
          center
          :close-on-click-modal="false"
          :show-close="false"
        >
          <el-form :model="form">
            <el-form-item label="选择组别">
              <el-select
                v-model="form.set_group_id"
                filterable
                placeholder="选择组别"
              >
                <el-option
                  v-for="(item, key) in resData.group"
                  :key="key"
                  :label="item"
                  :value="key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="批量入库">
              <el-input
                v-model="first_num"
                style="width: 30%; float: left"
                placeholder="五位数字"
                maxlength="5"
              ></el-input>
              <span style="float: left; margin-left: 5px; margin-right: 5px"
                >至</span
              >
              <el-input
                v-model="end_num"
                style="width: 30%; float: left"
                placeholder="五位数字"
                maxlength="5"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="manyVisible = false">取 消</el-button>
            <el-button type="primary" @click="genMany">确 定</el-button>
          </div>
        </el-dialog>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      clear_action: "",
      logVisible: false,
      clearVisible: false,
      resData: {},
      form: {
        pagesize: 50,
        is_excel: 0,
        multipleSelection: [],
      },
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      status_list: [
        {
          key: 1,
          value: "使用中",
        },
        {
          key: 2,
          value: "未使用",
        },
      ],
      origin: 1,

      loading: false,
      tableLoading: false,
      url: "/erp/box/index",
      curPage: 1,
      filterFold: false,
      bandVisible: false,
      title: "分箱入库",
      set_type: 1,
      box_nos: [],
      box_num: 0,
      set_box_no: "",
      manyVisible: false,
      first_num: "",
      end_num: "",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    genMany() {
      this.$confirm("是否确定入库", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 出库
        this.$http
          .post("/erp/box/genMany", {
            group_id: this.form.set_group_id,
            first_num: this.first_num,
            end_num: this.end_num,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.manyVisible = false;
              this.first_num = "";
              this.end_num = "";
              this.form.set_group_id = "";
              this.$message.success(res.data.msg);
              this.fetchData();
            }
          });
      });
    },
    unBand(box_id) {
      if (box_id) {
        this.form.multipleSelection = [box_id];
      }
      this.$confirm("是否确定解绑", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 出库
        this.$http
          .post("/erp/box/unBand", {
            box_ids: this.form.multipleSelection,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData();
            }
          });
      });
    },
    addNo() {
      if (this.box_nos.indexOf(this.set_box_no) >= 0) {
        this.set_box_no = "";
        return false;
      }
      this.box_num += 1;
      this.box_nos.push(this.set_box_no);
      this.set_box_no = "";
    },
    removeNo(tag) {
      this.box_num -= 1;
      this.box_nos.splice(this.box_nos.indexOf(tag), 1);
    },
    band() {
      if (this.set_type == 1) {
        this.$confirm("是否确定容器出库?(出库了不可恢复)", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // 出库
          this.$http
            .post("/erp/box/out", { box_nos: this.box_nos })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.box_nos = [];
                this.box_num = 0;
                this.fetchData();
              }
            });
        });
      } else {
        // 入库
        this.$http
          .post("/erp/box/in", {
            group_id: this.form.set_group_id,
            box_nos: this.box_nos,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.box_nos = [];
              this.box_num = 0;
              this.fetchData();
            }
          });
      }
    },
    selectOrigin(origin_id) {
      this.origin = origin_id;
      this.form.origin = origin_id;
      // if(this.origin != origin_id){
      //     this.$message.error('没有权限');
      // }
    },
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    exportExcel() {
      // this.loading = true;
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = parseInt(res.data.data.origin);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].box_id;
      }
      this.form.multipleSelection = multipleSelection;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    // 切换页码
    handleCurrentChange2(val) {
      // this.tableLoading = true;
      this.logcurPage = val;
      this.$http.get(`/erp/ShippingSpace/bandLog/page/${val}`).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.logInfo = res.data.data;
        }
      });
    },
    search() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/storagebox/index.vue